// extracted by mini-css-extract-plugin
export default {"page":"_cms_page__i1Rvo","grayBg":"_cms_grayBg__ZUzgR","campaign":"_cms_campaign__-tnJW"};